import { render, staticRenderFns } from "./SectionCases.vue?vue&type=template&id=5ee1e496&"
import script from "./SectionCases.vue?vue&type=script&lang=js&"
export * from "./SectionCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports